<template>
  <v-app-bar
    color="primary"
    app
  >
    <v-app-bar-nav-icon 
      class="white--text" 
      @click.stop="toggleNavbar">
      
      <v-icon>{{toggleNavbarIcon}}</v-icon>
    </v-app-bar-nav-icon>
    <v-subheader class="white--text">
      {{pageTitle}}
    </v-subheader>
    
    <!-- <layout-breadcrumbs/> -->
    <v-spacer/>
    <notifications/>
    <profile/>
  </v-app-bar>
</template>
<script>
  import {mapGetters} from 'vuex';
  import * as actions from '../../store/actions.type';
  // import LayoutBreadcrumbs from '@/components/layout/LayoutBreadcrumbs';
  import Profile from '@/components/widgets/AppProfile';
  import Notifications from '@/components/widgets/AppNotifications';

  export default {
    name: 'LayoutToolbar',
    components: {
      // LayoutBreadcrumbs,
      Profile,
      Notifications
    },
    computed: {
      ...mapGetters([
        'navbarShow',
      ]),
      toggleNavbarIcon() {
        return this.navbarShow ? 'chevron_left' : 'menu';
      },
      pageTitle() {
        return this.$route.meta.title;
      }
    },
    methods: {
      toggleNavbar() {
        this.$store.dispatch(actions.NAVBAR_TOGGLE);
      },
    },
  };
</script>